/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiJMESPathExpressionTestType {
    GENERAL = 'GENERAL',
    SCENARIO = 'SCENARIO',
    SEGMENT = 'SEGMENT'
}


export function instanceOfInternalApiJMESPathExpressionTestType(value: any): boolean {
    for (const key in InternalApiJMESPathExpressionTestType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiJMESPathExpressionTestType, key)) {
            if (InternalApiJMESPathExpressionTestType[key as keyof typeof InternalApiJMESPathExpressionTestType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiJMESPathExpressionTestTypeFromJSON(json: any): InternalApiJMESPathExpressionTestType {
    return InternalApiJMESPathExpressionTestTypeFromJSONTyped(json, false);
}

export function InternalApiJMESPathExpressionTestTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiJMESPathExpressionTestType {
    return json as InternalApiJMESPathExpressionTestType;
}

export function InternalApiJMESPathExpressionTestTypeToJSON(value?: InternalApiJMESPathExpressionTestType | null): any {
    return value as any;
}

export function InternalApiJMESPathExpressionTestTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiJMESPathExpressionTestType {
    return value as InternalApiJMESPathExpressionTestType;
}

